export default "__VITE_ASSET__$jRYjCgS__"